export enum DashboardCardType {
  Block,
  Container,
  Issue,
}
